import { useTranslation } from 'react-i18next';
import { GalleryPage } from './GalleryPage';

export function ErrorPage() {
  const { t } = useTranslation();

  return (
    <GalleryPage
      tone="error"
      title={t('Oops... something went wrong')}
      subtitle={t('Please refresh the page to try again.')}
    />
  );
}
